import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classnames from 'classnames';

import { Button } from 'ui-components/components/button';

import style from './navigation-button.module.less';

/**
 * @param {object} props
 * @param {React.ReactNode} props.children - Button content
 * @param {() => void} props.onClick - Click handler
 * @param {boolean} props.isSelected - Whether button is selected
 * @param {import('@fortawesome/fontawesome-common-types').IconDefinition} [props.icon] - FontAwesome icon definition
 * @param {string} [props.iconClassName] - Optional className for icon
 * @returns {JSX.Element}
 */
export const NavigationButton = ({ children, onClick, isSelected, icon, iconClassName }) => {
  return (
    <Button
      className={classnames(style['navigation-button'], {
        [style.selected]: isSelected,
      })}
      onClick={onClick}
      theme='unstyled'
    >
      {icon && <FontAwesomeIcon className={iconClassName} icon={icon} />}
      {children}
    </Button>
  );
};
